import { z } from 'zod';

export type AuctionSetDeliveryRequiredForm = {
    delivery_required: 0 | 1,
};

export type AuctionSetDeliveryRequiredFormErrors = {
    delivery_required?: string[],
};

export const AuctionSetDeliveryRequiredFormErrorsSchema = z.object({
    delivery_required: z.string().array().optional(),
});
